import { useTranslation } from 'react-i18next'

import LoadingIndicator from '@/widgets/LoadingIndicator'
import RozmowaForm from '../common/components/RozmowaForm'
import useRozmowaEditPage from './hooks/useRozmowaEditPage'

export default function RozmowaEdit() {
	const { t } = useTranslation()
	const {
		form,
		handleCancel,
		handleChange,
		handleClearPlacowka,
		handleSelectOsoba,
		handleSelectPlacowka,
		handleSubmit,
		loadError,
		loading,
		loadingOsoby,
		osoby,
		osobyError,
		selectedPlacowka,
		submitting,
	} = useRozmowaEditPage()

	if (loading) return <LoadingIndicator message={t('conversations.edit.loading')} />

	if (loadError) {
		return (
			<div className="min-h-screen flex items-center justify-center text-red-600">{loadError}</div>
		)
	}

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('conversations.edit.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
					<RozmowaForm
						mode="edit"
						form={form}
						onCancel={handleCancel}
						onChange={handleChange}
						onClearPlacowka={handleClearPlacowka}
						onSelectOsoba={handleSelectOsoba}
						onSelectPlacowka={handleSelectPlacowka}
						onSubmit={handleSubmit}
						loadingOsoby={loadingOsoby}
						osoby={osoby}
						osobyError={osobyError}
						selectedPlacowka={selectedPlacowka}
						submitting={submitting}
					/>
				</div>
			</div>
		</div>
	)
}
